import type { FetchResponse } from '@sydle/ui-api';
import { portalCustomAPI } from '.';

export interface GetImageInput {
  classId: string;
  objectId: string;
  imageId: string;
  width?: number;
  height?: number;
}

export type GetImageOutput = Blob;

export async function getImage(input: GetImageInput): Promise<FetchResponse<GetImageOutput>> {
  return await portalCustomAPI.fetch<GetImageInput, GetImageOutput>('getImage', input);
}
